import React from 'react';
import Section from './Section';

const FAQ = () => {
  return (
    <Section id="faq" title="FAQ">
      <p>Frequently asked questions about eligibility, team formation, prizes, and logistics will be answered here.</p>
    </Section>
  );
};

export default FAQ;
